export default __webpack_public_path__ + "static/media/banner_1b.3a36967e.jpg";